export enum ElementStatus{
  Outlined,
  Skipped,
  Executed
}